module.exports = __webpack_public_path__ + "static/media/arvsfonden-full.fc76a40f.png";